import { MonoTypeOperatorFunction, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

const DESTROY$ = Symbol('destroy$');

export interface OnDestroy {
  ngOnDestroy(): void;
}

/**
 * @example
 * ```typescript
 * this.myService.getData()
 *   .pipe(untilDestroyed(this))
 *   .subscribe(data => console.log(data));
 * ```
 */
export function untilDestroyed<T>(
  component: OnDestroy
): MonoTypeOperatorFunction<T> {
  if (!(component as any)[DESTROY$]) {
    (component as any)[DESTROY$] = new Subject<void>();

    const originalDestroy = component.ngOnDestroy;

    component.ngOnDestroy = function (this: OnDestroy) {
      if (originalDestroy) {
        originalDestroy.apply(this);
      }

      (this as any)[DESTROY$].next();
      (this as any)[DESTROY$].complete();
    };
  }

  return takeUntil((component as any)[DESTROY$]);
}
